// 时间转换
function timeFilter(stringTime, a, b, c, d, e) {
    stringTime = stringTime * 1000
    var minute = 1000 * 60;
    var hour = minute * 60;
    var day = hour * 24;
    var week = day * 7;
    var month = day * 30;
    var time1 = new Date().getTime();//当前的时间戳
    var time2 = Date.parse(new Date(stringTime));//指定时间的时间戳
    var time = time1 - time2;
    var result = null;
    if (time / week >= 1) {
        result = formatTimestamp(stringTime);
    } else if (time / day >= 1) {
        result = a + parseInt(time / day) + b;
    } else if (time / hour >= 1) {
        result = a + parseInt(time / hour) + c;
    } else if (time / minute >= 1) {
        result = a + parseInt(time / minute) + d;
    } else {
        result = e;
    }
    return result
}
function formatTimestamps(timestamp) {
    const date = new Date(timestamp);
    const year = date.getFullYear();
    const month = addZero(date.getMonth() + 1);
    const day = addZero(date.getDate());
    const hours = addZero(date.getHours());
    const minutes = addZero(date.getMinutes());
    const seconds = addZero(date.getSeconds());
    return `${year}-${month}-${day} ${hours}:${minutes}`;
}
// 时间戳转年月日时分秒
function formatTimestamp(timestamp) {
    const date = new Date(timestamp);
    const year = date.getFullYear();
    const month = addZero(date.getMonth() + 1);
    const day = addZero(date.getDate());
    const hours = addZero(date.getHours());
    const minutes = addZero(date.getMinutes());
    const seconds = addZero(date.getSeconds());
    return `${year}-${month}-${day}`;
}
function formatTimestampsm(timestamp) {
    const date = new Date(timestamp);
    const year = date.getFullYear();
    const month = addZero(date.getMonth() + 1);
    const day = addZero(date.getDate());
    const hours = addZero(date.getHours());
    const minutes = addZero(date.getMinutes());
    const seconds = addZero(date.getSeconds());
    return `${year}-${month}-${day} ${hours}:${minutes}`;
}
function addZero(value) {
    return value < 10 ? `0${value}` : value;
}

function setSEO({ title, description, image, url, keywords, type = 'website' }) {
    // 设置基础meta
    const baseTags = [
        // 标准meta
        { name: 'title', content: title },
        { name: 'description', content: description },
        { name: 'keywords', content: keywords },
        
        // Open Graph
        { property: 'og:title', content: title },
        { property: 'og:description', content: description },
        { property: 'og:image', content: image },
        { property: 'og:url', content: url || window.location.href },
        { property: 'og:type', content: type },
        
        // Twitter Card
        { name: 'twitter:card', content: 'summary_large_image' },
        { name: 'twitter:title', content: title },
        { name: 'twitter:description', content: description },
        { name: 'twitter:image', content: image },
        
        // 移动端适配
        { name: 'mobile-web-app-capable', content: 'yes' },
        { name: 'apple-mobile-web-app-title', content: title }
    ];

    // 动态更新或创建标签
    baseTags.forEach(tag => {
        let selector = '';
        if (tag.property) selector = `meta[property="${tag.property}"]`;
        if (tag.name) selector = `meta[name="${tag.name}"]`;
        
        let element = document.querySelector(selector);
        if (!element) {
            element = document.createElement('meta');
            if (tag.property) element.setAttribute('property', tag.property);
            if (tag.name) element.setAttribute('name', tag.name);
            document.head.appendChild(element);
        }
        element.setAttribute('content', tag.content || '');
    });

    // 设置页面标题
    document.title = title || document.title;
}

function shareTo(platform , configObj) {
    let shareUrl = "";
    switch (platform) {
        case "facebook":
            shareUrl = `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(
                configObj.url
            )}`;
            break;
        case "line":
            shareUrl = `https://social-plugins.line.me/lineit/share?url=${encodeURIComponent(
                configObj.url
            )}`;
            break;
        case "twitter":
            shareUrl = `https://twitter.com/intent/tweet?text=${encodeURIComponent(
                configObj.title
            )}&url=${encodeURIComponent(configObj.url)}`;
            break;
    }
    window.open(shareUrl, "_blank", "width=600,height=400");
}


export {
    timeFilter,
    formatTimestampsm,
    formatTimestamp,
    formatTimestamps,
    setSEO,
    shareTo
}